import { Mouvement } from '@mairistem/comptabilite';
import { getErrorMessage } from '@mairistem/finances-utils';
import MouvementActionType from '../../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import BaseLiquidationAction from '../../../pieces/BaseLiquidationAction';
import ActionResultType from '../../../../interfaces/pieces/ActionResultType';
import TreeviewActionResult from '../../../../interfaces/pieces/TreeviewActionResult';
import type { BaseLiquidationOptions } from '../../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import { dupliquerMouvement } from '../../../../services/piecesComptables/mouvements/mouvements';

class MouvementDupliquerAction extends BaseLiquidationAction<Mouvement, MouvementActionType> {
  constructor(options: BaseLiquidationOptions = null) {
    super(options);
    this.label = 'Dupliquer';
    this.type = MouvementActionType.DUPLIQUER;
    this.isShown = (bordereau) => bordereau.typePes !== '02';
  }

  execute = (mouvement: Mouvement): TreeviewActionResult<Mouvement> => ({
    type: ActionResultType.MODAL,
    result: Promise.resolve(mouvement),
    extraProps: {
      isSuperUser: this.isSuperUser,
      mouvementDuplicationModal: {
        visible: true,
        typeAction: MouvementActionType.DUPLIQUER,
      },
    },
  });

  executeAction = (
    mouvement: Mouvement & {
      shouldReprendreReferences?: boolean,
      bordereauIsModel?: boolean,
      dateEcheance?: string,
      datePrelevement?: string,
      dateRealisationPrestationDebut?: string,
      dateRealisationPrestationFin?: string,
      updatedIdBordereau?: number,
    },
  ): TreeviewActionResult<Mouvement & { isAnotherBordereau: boolean, isNewBordereau: boolean }> => {
    const isAnotherBordereau = mouvement.updatedIdBordereau !== mouvement.identifiantBordereau;
    return {
      type: ActionResultType.ADD,
      result: new Promise((resolve, reject) => {
        dupliquerMouvement(
          { ...mouvement, identifiantBordereau: mouvement.updatedIdBordereau },
          mouvement.shouldReprendreReferences,
          mouvement.bordereauIsModel,
          mouvement.dateEcheance,
          mouvement.dateDepartDelaiGlobalPaiement,
          mouvement.datePrelevement,
          mouvement.dateRealisationPrestationDebut,
          mouvement.dateRealisationPrestationFin,
          mouvement.bordereau,
        ).then((newMouvement) => {
          resolve({
            ...newMouvement,
            isAnotherBordereau,
            isNewBordereau: !!mouvement.bordereau,
          });
        }).catch((e) => {
          reject(Error(getErrorMessage(e, 'Erreur lors de la duplication du mouvement')));
        });
      }),
      shouldRefreshChildren: true,
    };
  };
}

export default MouvementDupliquerAction;
